module.exports = __webpack_public_path__ + "media/images/ohap_assignment indicator_off-b69d2b9911bf14503bfbc9bdd453b80a.png";